/**
 * @fileoverview Загрузчик hc/funnel
 *     Создает экземпляр API и подменяет им временную функцию,
 *     созданную в  сниппете {@see ./snippet.js}
 */

(function(win, Api) {
  // Находим имя временной функцию
  var name = win['HcFunnelGlobal'] || 'hcfunnel';

  // Находим временную функцию
  var temp = win[name];

  // метки времени инициализации сниппета и счётчика
  var timings = {
    init_time: temp && temp.t,
    load_time: Date.now()
  }

  // ключ в глобальном контектсе для проверки загрузки фаннела
  var funnelLoadedName = 'hc_funnel_loaded_success';


  // проверям, что скрипт загружен только 1 раз
  if (win[funnelLoadedName]) {
    // скрипт загружен дважды
    temp('event', 'frontend', 'funnel', 'alreadyloaded', timings, {}, {
      force: true
    });

    if (module) {
      module.exports = temp;
    }
    return temp;
  }

  // Оборачиваем апи функцией, закрывающей все методы, кроме PublicCommands
  var api = require('../interfase').getInterface(new Api(), Api.PublicCommands);

  var urlName = win['HcFunnelGlobalUrl'] || 'hcfunnelurl';
  if (win[urlName]) {
    api('url', win[urlName]);
  }

  // Из временной функции вытаскиваем время создания
  // и очередь, чтобы скормить настоящей апишке
  if (temp) {
    var queue = temp.q || [];
    for (var i = 0, l = queue.length; i < l; i++) {
      api.apply(null, queue[i]);
    }
  }

  // Подменяем временную функцию на настоящую
  win[name] = api;

  // запомнинаем, что скрипт уже загружен
  win[funnelLoadedName] = true;

  // Подтверждаем загрузку
  api('event', 'frontend', 'funnel', 'loaded', timings, {}, {
    force: true
  });

  // Принудительно отправляем фаннел, в случае если код на странице поставлен,
  // но вызова send не было длительное время
  setTimeout(function() {
    if (!api('wasSent')) {
      api('send', {platform: '__init'});
    }
  }, 5000);

  if (module) {
    module.exports = api;
  }
})(window, require('./funnel'));



//////////////////
// WEBPACK FOOTER
// ./lib/funnel/index.js
// module id = 0
// module chunks = 1 3